module.exports = {"ADM_EDIT_USER_PERSONAL_INFO":"Informasi pribadi","ADM_EDIT_USER_LOCATION_AND_PHONE":"Lokasi dan nomor ponsel","ADM_EDIT_USER_SAVE":"Simpan"}